import { render, staticRenderFns } from "./AssignmentsAccommodationList.vue?vue&type=template&id=4a3d45f0&scoped=true"
import script from "./AssignmentsAccommodationList.vue?vue&type=script&lang=js"
export * from "./AssignmentsAccommodationList.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsAccommodationList.vue?vue&type=style&index=0&id=4a3d45f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d45f0",
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField});
